
import {
  IObjektVyGruppProps,
  ObjektVyKort,
} from '../ObjektVyKort/ObjektVyKort';
import { ObjektVyFaltLista } from '../ObjektVyFaltLista/ObjektVyFaltLista';

interface IProps extends IObjektVyGruppProps {}

const AttributGrupp: React.FC<React.PropsWithChildren<IProps>> = props => {
  return (
    <ObjektVyKort {...props}>
      <ObjektVyFaltLista>{props.children}</ObjektVyFaltLista>
    </ObjektVyKort>
  );
};

export default AttributGrupp;
